// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TimerClockFace_wrapper__1utP6","clockface-item":"TimerClockFace_clockface-item__2MZSQ","separator":"TimerClockFace_separator__up6rK"};